import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import constants from "../../assets/constants";
import * as AdminSessionActions from "../../state/redux/adminSession";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import SurveyInvites from "../ui/surveyInvites";

const SelectInviteDialog = props => {
  const {
    open,
    dialogTitle = "Select Shared Invite",
    cancelMessage = "Cancel",
    maxWidth = "md",
    fullWidth = true,
    onSelectSharedInvite,
    sharedInviteODMs,
    loadSharedInvitesRequest,
    sharedInvitePageLoading,
    sharedInvitePagination,
    onClose,
  } = props;

  const theme = useTheme();

  const onCloseHandler = () => {
    props.onClose();
  };

  useEffect(() => {
    if (sharedInviteODMs != null) {
      setRows(sharedInviteODMs);
    }
  }, [sharedInviteODMs]);

  const [rows, setRows] = useState([]);

  const [selectedInvite, setSelectedInvite] = useState(null);

  useEffect(() => {
    if (selectedInvite != null) {
      onSelectSharedInvite(selectedInvite);
      onClose();
    }
  }, [selectedInvite, onClose, onSelectSharedInvite]);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Typography variant="overline" sx={{ marginBottom: `-${theme.spacing(0.5)}` }}>
            Select a Shared Invite
          </Typography>
          <Grid container item spacing={1}>
            <Box
              sx={{
                width: "100%",
              }}
            >
              <SurveyInvites
                inviteODMs={rows}
                onSelectInvite={setSelectedInvite}
                inviteSurveyType={constants.inviteSurveyType.shared}
                onRequestNewPage={loadSharedInvitesRequest}
                isLoading={sharedInvitePageLoading}
                invitePagination={sharedInvitePagination}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid container item justifyContent="flex-end" xs={12} spacing={1}>
            <Grid item>
              <Button onClick={onCloseHandler} color="secondary" variant="contained">
                {cancelMessage}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  sharedInviteODMs: state.adminSession.sharedInviteODMs,
  sharedInvitePageLoading: state.adminSession.sharedInvitePageLoading,
  sharedInvitePagination: state.adminSession.sharedInvitePagination,
});

const mapDispatchToProps = {
  loadSharedInvitesRequest: AdminSessionActions.loadSharedInvitesRequest,
  reflectUpdatedInviteODMRequest: AdminSessionActions.reflectUpdatedInviteODMRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectInviteDialog);
